import { RootState } from '../../store';
import EveryDoggyAPIServices from '../../utils/services/EveryDoggyAPIServices';
import { WebCatalogProduct } from '../../utils/services/EveryDoggyAPITypes';
import { DATA_ACTION_TYPES, setProductDetailsOnInitScreen } from './actions';

const dataMiddleware = ({ getState }) => {
  return function (next) {
    return function (action) {
      if (action.type === DATA_ACTION_TYPES.SET_PAYMENT_PRODUCT) {
        // check payload
        if (!action.payload) return next(action);

        const payload = JSON.parse(action.payload);

        EveryDoggyAPIServices.getWebCatalogProduct(payload.product).then(data => {
          // do not save nothing
          if (!data) return next(action);
          const productDetails = data;

          // Save to state init product
          const state: RootState = getState();
          const productOnInitScreenDetails: null | WebCatalogProduct = state.data.productOnInitScreen.details;
          if (!productOnInitScreenDetails) {
            next(
              setProductDetailsOnInitScreen({
                name: action.payload,
                details: {
                  ...productDetails,
                  oldPrice: payload.oldPrice,
                },
              })
            );
          }

          return next({
            ...action,
            details: productDetails,
          });
        }).catch(() => {
          next(action);
        });
      } else if (action.type === DATA_ACTION_TYPES.SET_DIGITAL_PRODUCT) {
        if (!action.payload) return next(action);
        return next({
          ...action,
          productList: action.payload,
        });
      } else return next(action);
    };
  };
};

export default dataMiddleware;
